/**
 * Frontend re-export of progressive insight helpers.
 * Uses require() for CRA/babel interop with @stavyn/shared subpath exports.
 */
const {
  INSIGHT_TIER,
  employeeHasUsableData,
  computeDataCompleteness,
  completenessTier,
  buildPartialEmployeeInsight,
  resolveProgressiveInsight,
  progressiveFallbackLabel,
  isHardBlockPhrase,
} = require('@stavyn/shared/progressiveInsight');

export {
  INSIGHT_TIER,
  employeeHasUsableData,
  computeDataCompleteness,
  completenessTier,
  buildPartialEmployeeInsight,
  resolveProgressiveInsight,
  progressiveFallbackLabel,
  isHardBlockPhrase,
};
